'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PatentanzahlResource = _require2.PatentanzahlResource;

module.exports.Patentanzahl = function (_BaseEntity) {
  _inherits(Patentanzahl, _BaseEntity);

  _createClass(Patentanzahl, null, [{
    key: '__name__',
    value: function __name__() {
      return 'patentanzahl';
    }
  }]);

  function Patentanzahl(data) {
    _classCallCheck(this, Patentanzahl);

    var _this = _possibleConstructorReturn(this, (Patentanzahl.__proto__ || Object.getPrototypeOf(Patentanzahl)).call(this));

    _this._entityName = 'de.ul.fob.domain.Patentanzahl';
    _this.anzahl = null;
    _this.jahr = null;

    _this.organisationseinheit = null;
    _get(Patentanzahl.prototype.__proto__ || Object.getPrototypeOf(Patentanzahl.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Patentanzahl, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'anzahl', 'jahr'],
        links: ['organisationseinheit']
      });
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Patentanzahl.prototype.__proto__ || Object.getPrototypeOf(Patentanzahl.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Patentanzahl.prototype.__proto__ || Object.getPrototypeOf(Patentanzahl.prototype), 'genericResolve', this).call(this, 'organisationseinheit')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PatentanzahlResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Patentanzahl.prototype.__proto__ || Object.getPrototypeOf(Patentanzahl.prototype), 'fetchQuery', this).call(this, PatentanzahlResource);
      }
    }
  }]);

  return Patentanzahl;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/patentanzahl.js
// module id = KTKN
// module chunks = 0